<script setup lang="ts"></script>

<template>
  <svg width="32" height="15" viewBox="0 0 32 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32 0L-6.99382e-07 1.39876e-06L13.1716 13.1716C14.7337 14.7337 17.2663 14.7337 18.8284 13.1716L32 0Z"
      fill="currentColor"
    />
  </svg>
</template>
